/**
 * @fileoverview 画面に出すサービス名の出し分け（船員アプリ）
 * @description 「カツオ勤怠」は営業・デモ用の名義。実顧客の船員には出さない。
 *   会社ごとにAPKを分けていても中身は同じビルドなので、ホスト名で切り替える。
 *   （2026-08-27: 実顧客の画面に「カツオ勤怠」表記が出ていたため追加）
 */

/** デモ・検証用のサブドメイン（<会社>.crew.unison-sea.com の先頭ラベル） */
const DEMO_SUBDOMAINS = ['test', 'test-kaisya', 'portal', 'portal-test'];

export function isDemoHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return false;
  const first = host.split('.')[0] ?? '';
  return DEMO_SUBDOMAINS.includes(first);
}

/** ヘッダー等に出すサービス名 */
export const BRAND_NAME = isDemoHost() ? 'カツオ勤怠' : 'CATMS';
